// extracted by css-extract-rspack-plugin
export default {"trigger":"DiWJ3mWhe4N9zPkN"};